// export const CONDITION_OPERATOR = {
//   CurrencyField: ["<", ">", "<=", ">=", "==", "!="],
//   DateField: ["Before", "After"],
//   NumericField: ["<", ">", "<=", ">=", "==", "!="],
//   PercentField: ["<", ">", "<=", ">=", "==", "!="],
//   SingleSelectField: ["==", "!="],
//   StringField: ["Equal", "Not Equal"],
// };

export const CHAR_OPERATORS = [
  "Equal",
  "Not Equal",
  "Greater Than",
  "Greater Than Equal",
  "Less Than",
  "Less Than Equal",
];

export const CONDITION_OPERATOR = {
  CurrencyField: CHAR_OPERATORS,
  DateField: ["Before", "After"],
  NumericField: CHAR_OPERATORS,
  PercentField: CHAR_OPERATORS,
  SingleSelectField: ["Equal", "Not Equal"],
  StringField: ["Equal", "Not Equal"],
};

export const OPERATORS_MAPPING = {
  "==": "Equal",
  "!=": "Not Equal",
  ">": "Greater Than",
  ">=": "Greater Than Equal",
  "<": "Less Than",
  "<=": "Less Than Equal",
};

export const OPERATORS_REVERSE_MAPPING = {
  Equal: "==",
  "Not Equal": "!=",
  "Greater Than": ">",
  "Greater Than Equal": ">=",
  "Less Than": "<",
  "Less Than Equal": "<=",
};

const ACTION_EMAILS_AND_SUBS = {
  emailSub: "[Approval Request] from {deal_owner_name} for {document_name} ",
  emailMsg: `{deal_owner_name} has requested approval on the following deal \n
Message:
{requester_note} \n
Deal Details
Document type: {doc_type}
Account Name: {account}
Opportunity Name:  {opportunity}
Deal Value: {deal_value}
    `,
  replySub:
    "Your {document_name} has been {approval_status} by {approver_name}",
  replyMsg: `{approver_name} has {approval_status} approval on the following deal \n
Message:
{approver_note} \n
Deal Details
Document type: {doc_type}
Account Name: {account}
Opportunity Name:  {opportunity}
Deal Value: {deal_value}
    `,
};

export const FORM_FIELD_DATA = {
  condition: {
    conditions: [],
    logicalOperator: "AND",
    priceBook: {},
    product: {},
    showOperators: false,
    type: "",
  },
  action: {
    approvalType: "Sequential",
    approvers: [{}],
    emailMsg: ACTION_EMAILS_AND_SUBS.emailMsg,
    emailSub: ACTION_EMAILS_AND_SUBS.emailSub,
    followers: [],
    followersMsg: "",
    quorum: 0,
    replyMsg: ACTION_EMAILS_AND_SUBS.replyMsg,
    replySub: ACTION_EMAILS_AND_SUBS.replySub,
    triggerMessage: "",
  },
};



// WEBPACK FOOTER //
// ./src/constants/workflow.js